(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-claude"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll(".announcement-bar__scroller").forEach(function (scroller) {
    var track = scroller.querySelector(".announcement-bar__track");
    var originalSet = track && track.querySelector(".announcement-bar__set");
    if (!track || !originalSet) return;

    var pauseOnHover = scroller.dataset.pauseOnHover === "true";

    function init() {
      var cycleWidth = originalSet.offsetWidth;
      if (!cycleWidth) return;

      var needed = Math.ceil((window.innerWidth * 4) / cycleWidth) + 1;
      var current = track.querySelectorAll(".announcement-bar__set").length;

      for (var i = current; i < needed; i++) {
        var clone = originalSet.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        track.appendChild(clone);
      }

      track.style.setProperty("--ann-translate", "-" + cycleWidth + "px");
      track.classList.add("is-animating");
    }

    if (document.fonts) {
      document.fonts.ready.then(init);
    } else {
      init();
    }

    if (pauseOnHover) {
      scroller.addEventListener("mouseenter", function () { track.classList.add("is-paused"); });
      scroller.addEventListener("mouseleave", function () { track.classList.remove("is-paused"); });
      scroller.addEventListener("focusin", function () { track.classList.add("is-paused"); });
      scroller.addEventListener("focusout", function () { track.classList.remove("is-paused"); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
